import { BigFormRow, MediumFormRow } from 'framework/ui/layout';
import { useMemo } from 'react';
import { Box } from '@mui/material';
import { ClearAfterUnmountWrapper, useFormContext, EnumDropdown, TextInput } from 'framework/form';
import { useDidUpdateEffect } from 'framework/utils';
import {
  TYPES_BY_SECTIONS_EMPLOYEE_DOC,
  EMPLOYEE_DOCUMENT_SECTIONS,
  EMPLOYEE_DOCUMENT_SECTIONS_VALUES,
  EMPLOYEE_DOCUMENT_CATEGORY,
} from '../constants';
import { getEmployeeDocumentDefaultStage, getEmployeeDocumentStageOptions } from '../stageRules';
import { ARTIFACT_ID } from 'domain/shared/artifact';
import { ArtifactUploaderInput } from 'domain/shared/artifact/input';
import { EmployeeDocumentFormShowType } from '../types';
import { isPolishOffice, OfficeDropdown } from 'domain/shared/employee';

const EmployeeDocumentsForm = ({ isEditForm = false }: { isEditForm?: boolean }) => {
  const { data = {}, onChangeCallback } = useFormContext();

  const { section, fileType } = data;

  const typeOptions = TYPES_BY_SECTIONS_EMPLOYEE_DOC[section] || [];

  const stageOptions = useMemo(() => getEmployeeDocumentStageOptions(section, fileType), [section, fileType]);

  useDidUpdateEffect(() => {
    onChangeCallback!({
      stage: getEmployeeDocumentDefaultStage(section, fileType),
    });
  }, [section, fileType]);

  useDidUpdateEffect(() => {
    onChangeCallback!({
      fileType: '',
    });
  }, [section]);

  return (
    <Box>
      <MediumFormRow>
        <EnumDropdown options={EMPLOYEE_DOCUMENT_SECTIONS_VALUES} label="" placeholder="Section" source="section" />
        <EnumDropdown options={typeOptions} label="" placeholder="Type" source="fileType" />
      </MediumFormRow>

      <MediumFormRow>
        <EnumDropdown label="" placeholder="Stage" source="stage" options={stageOptions} />
        <OfficeDropdown label="" placeholder="Office" source="office" />
      </MediumFormRow>

      <MediumFormRow>
        <ClearAfterUnmountWrapper
          isVisible={(formData: EmployeeDocumentFormShowType) =>
            isPolishOffice(String(formData?.office)) && Boolean(formData?.isPolishContractEmployee)
          }
        >
          <EnumDropdown options={EMPLOYEE_DOCUMENT_CATEGORY} label="" placeholder="Category" source="category" />
        </ClearAfterUnmountWrapper>

        <ClearAfterUnmountWrapper
          isVisible={(formData: EmployeeDocumentFormShowType) =>
            formData.section === EMPLOYEE_DOCUMENT_SECTIONS.HR ||
            (isPolishOffice(String(formData?.office)) && Boolean(formData?.isPolishContractEmployee))
          }
        >
          <TextInput label="" placeholder="Number" source="number" />
        </ClearAfterUnmountWrapper>
      </MediumFormRow>

      <BigFormRow>
        <ArtifactUploaderInput
          artifactTypeId={ARTIFACT_ID.NOTE_ATTACHMENT}
          isVisible={!isEditForm}
          isNewDocumentStorage
          label=""
          source="paths"
        />
      </BigFormRow>
    </Box>
  );
};

export default EmployeeDocumentsForm;
